import { createFileRoute, redirect } from "@tanstack/react-router";

import { groupApi } from "~/api";

export const Route = createFileRoute("/_authenticated/_no-building/groups/")({
  loader: async ({ context: { queryClient } }) => {
    const groups = await queryClient.ensureQueryData(groupApi.queries.all);
    if (groups.length === 0) return redirect({ to: "/buildings" });
    const firstGroup = groups[0];
    if (!firstGroup) return redirect({ to: "/buildings" });
    return redirect({ to: "/groups/$groupId/buildings", params: { groupId: firstGroup.id } });
  },
});
